import React from 'react';
import { observer } from 'mobx-react';

interface IProps {
  coins: number;
}

const AppHeaderScore: React.FC<IProps> = observer(({ coins }) => {
  return (
    <span>
      <i className="nes-icon coin"></i>X<span style={{ fontSize: '26px' }}>{`${coins}`.padStart(2, '0')}</span>
    </span>
  );
});

export default AppHeaderScore;
